import { Directive, Input, ElementRef, Renderer2, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[dataTestId]',
})
export class DataTestIdDirective implements OnInit {
  @Input() dataTestId: string;

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    if (this.dataTestId && !environment.production) {
      this.renderer.setAttribute(this.el.nativeElement, 'data-testid', this.dataTestId);
    }
  }
}
